export default __webpack_public_path__ + "static/media/servo.9a76f3d7.svg";